import React, { useState, useEffect, useRef } from 'react';
import Box from '@mui/material/Box';
import { useAuthUser } from '@projectK/hooks/AuthHooks';
import jwtAxios from '@projectK/services/auth/JWT';
import { IonLabel, IonSegment, IonSegmentButton } from '@ionic/react';
import { useMobileSettings } from '@projectK/context/MobileContextProvider';
import {
  isParent,
  isSuperAdmin,
  isAdmin,
} from '@projectK/context/RolesProvider';
import ActivitySchedules from '../../../../../../../apps/admin/src/modules/parent/Dashboard/ActivitySchedules';
import UpcomingActivities from '../../../../../../../apps/admin/src/modules/parent/Dashboard/UpcomingActivities';
import ActivityWaitlist from '../../../../../../../apps/admin/src/modules/parent/Dashboard/ActivityWaitlist';
import MyProducts from '../../../../../../../libs/modules/src/lib/account/MyProfile/MyProducts';
import { Capacitor } from '@capacitor/core';
import GracePeriodBanner from '../../../../../../components/src/lib/AppLayout/MiniSidebarToggle/GracePeriodBanner';
import { useMissedPaymentSettings } from '@projectK/context/checkMissedPayments';
const EventsSchedule = () => {
  const { user } = useAuthUser();
  const [value, setValue] = useState(0);
  const handleChange = (event, newValue) => {
    setValue(isMobile ? parseInt(event.detail.value) : newValue);
  };
  const { isMobile, mobileMode } = useMobileSettings();
  const [myProducts, setMyProducts] = useState([]);
  const [myProductsLoading, setMyProductsLoading] = useState(true);
  const [isAddProductModalOpen, setIsAddProductModalOpen] = useState(false);
  const [isAdjustCreditsModalOpen, setIsAdjustCreditsModalOpen] =
    useState(false);
  const { checkGracePeriodPayment } = useMissedPaymentSettings();
  useEffect(() => {
    fetchUserProduct();
  }, [user?.id]);

  const fetchUserProduct = async () => {
    try {
      setMyProductsLoading(true);
      const route = isParent(user)
        ? `/products/productname/parent/${user?.id}`
        : `/products/productname/${user?.id}`;
      const response = await jwtAxios.get(route);
      const { data } = response;
      setMyProducts(data);
      // Optional: store it in state if you want to display it in the UI
      setMyProductsLoading(false);
    } catch (error) {
      setMyProducts([]);
      setMyProductsLoading(false);
    }
  };

  const openAddProductsModal = () => {
    setIsAddProductModalOpen(true);
  };
  /********************************End of My Products******************************/
  //********************************ActivitySession********************************//

  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showAll, setShowAll] = useState(true);
  const [search, setSearch] = useState('');
  const [useDateFilter, setUseDateFilter] = useState(true);
  const abortControllerRef = useRef(null);
  const fetchActivitySessions = async () => {
    setLoading(true);
    abortControllerRef.current = new AbortController();
    const { signal } = abortControllerRef.current;
    try {
      const routeDate = isParent(user)
        ? '/user-members/session'
        : '/activity-session/user/session';

      const response = await jwtAxios.get(`${routeDate}/${user?.id}`, {
        params: {
          perPage: 'all',
          useDateFilter: useDateFilter,
          search,
        },
        signal,
      });
      const { data } = response;
      setList(data?.list);
      setLoading(false);
    } catch (error) {
      if (error.message !== 'canceled') {
        setLoading(false);
      }
    }
  };

  useEffect(() => {
    fetchActivitySessions();
    return () => {
      if (abortControllerRef.current) {
        abortControllerRef.current.abort();
      }
    };
  }, [useDateFilter, search]);

  /*****************************My Schedule**************************/

  const [currentActivity, setCurrentActivity] = useState(null);
  const [scheduleLoading, setScheduleLoading] = useState(true);
  const [useDateFilterSession, setUseDateFilterSession] = useState(false);
  const [searchSession, setSearchSession] = useState('');
  const [showAllSession, setShowAllSession] = useState(false);

  const fetchMySchedule = async () => {
    try {
      setScheduleLoading(true);
      const routeDate = isParent(user)
        ? '/user-members/active-session'
        : '/activity-session/user/active-session';
      const response = await jwtAxios.get(`${routeDate}/${user?.id}`, {
        params: {
          perPage: 'all',
          useDateFilter: useDateFilterSession,
          search: searchSession,
        },
      });
      const { data } = response;
      setCurrentActivity(data?.list);
      setScheduleLoading(false);
    } catch (error) {
      console.error(`error while getting myschedule', ${error}`);
      setScheduleLoading(false);
    }
  };

  useEffect(() => {
    fetchMySchedule();
  }, [useDateFilterSession, searchSession]);

  /***************************Wait List******************************/
  const [waitListData, setWaitListData] = useState(null);
  const [waitListLoading, setWaitListLoading] = useState(true);

  const fetchWaitList = async () => {
    try {
      setWaitListLoading(true);
      let url;
      if (isParent(user)) {
        url = `/user-members/waitlist-session/${user?.id}`;
      } else if (isSuperAdmin(user) || isAdmin(user)) {
        url = `/user-waitlist`;
      } else {
        url = `/activity-session/user/waitlist-session/${user?.id}`;
      }
      const response = await jwtAxios.get(url, {
        params: { perPage: 'all' },
      });
      const { data } = response;
      setWaitListData(data?.list);
      setWaitListLoading(false);
    } catch (error) {
      setWaitListLoading(false);
    }
  };

  useEffect(() => {
    fetchWaitList();
  }, []);
  return (
    <>
      <div
        className={
          Capacitor.getPlatform() === 'android'
            ? 'custom-card-header'
            : 'custom-card-header-ios'
        }
      >
        <div className='title-container'>
          <div className='custom-title1'>
            Welcome back {user?.first_name} {user?.last_name}
          </div>
        </div>
      </div>
      {checkGracePeriodPayment.length > 0 ? (
        <GracePeriodBanner
          checkGracePeriodPayment={checkGracePeriodPayment}
          className={'mobile'}
        />
      ) : null}
      <IonSegment
        mode={mobileMode}
        value={value}
        onIonChange={handleChange}
        id='mobile-tabs'
      >
        <IonSegmentButton value={0}>
          <IonLabel style={{ textTransform: 'none' }}>My Schedules</IonLabel>
        </IonSegmentButton>
        <IonSegmentButton value={1}>
          <IonLabel style={{ textTransform: 'none' }}>Upcoming</IonLabel>
        </IonSegmentButton>
        <IonSegmentButton value={2}>
          <IonLabel style={{ textTransform: 'none' }}>Waitlist</IonLabel>
        </IonSegmentButton>
      </IonSegment>
      <Box
        style={{
          marginTop: '20px',
          border: '2px solid #377df6',
          borderRadius: '8px',
          padding: '15px',
          paddingTop: '10px',
          marginLeft: '7px',
          marginRight: '7px',
        }}
      >
        {value === 0 && (
          <ActivitySchedules
            fetchActivitySessions={fetchActivitySessions}
            list={currentActivity}
            loading={scheduleLoading}
            fetchMySchedule={fetchMySchedule}
            fetchUserProduct={fetchUserProduct}
            setDateFilter={setUseDateFilterSession}
            useDateFilter={useDateFilterSession}
            setSearchQuery={setSearchSession}
            searchSession={searchSession}
            setShowAll={setShowAllSession}
            showAll={showAllSession}
            setLoading={setScheduleLoading}
          />
        )}
        {value === 1 && (
          <UpcomingActivities
            list={list}
            loading={loading}
            setLoading={setLoading}
            setList={setList}
            setDateFilter={setUseDateFilter}
            setSearchQuery={setSearch}
            setShowAll={setShowAll}
            showAll={showAll}
            useDateFilter={useDateFilter}
            fetchActivitySessions={fetchActivitySessions}
            fetchMySchedule={fetchMySchedule}
            fetchUserProduct={fetchUserProduct}
            fetchWaitList={fetchWaitList}
          />
        )}
        {value === 2 && (
          <ActivityWaitlist
            waitListData={waitListData}
            loading={waitListLoading}
            fetchWaitList={fetchWaitList}
            fetchActivitySessions={fetchActivitySessions}
            fetchUserProduct={fetchUserProduct}
            setLoading={setWaitListLoading}
          />
        )}
      </Box>
      <Box
        style={{
          marginTop: '20px',
          border: '2px solid #377df6',
          borderRadius: '8px',
          padding: '15px',
          marginLeft: '7px',
          marginRight: '7px',
          marginBottom: '100px',
        }}
      >
        <MyProducts
          loading={myProductsLoading}
          setLoading={setMyProductsLoading}
          settings={myProducts}
          fetchUserProduct={fetchUserProduct}
          isModalOpen={isAddProductModalOpen}
          setIsModalOpen={setIsAddProductModalOpen}
          openModal={openAddProductsModal}
          setIsAdjustCreditsModalOpen={setIsAdjustCreditsModalOpen}
          isAdjustCreditsModalOpen={isAdjustCreditsModalOpen}
          fetchMySchedule={fetchMySchedule}
          fetchWaitList={fetchWaitList}
          fetchActivitySessions={fetchActivitySessions}
        />
      </Box>
    </>
  );
};

export default EventsSchedule;
